<template>
  <div class="dashboard">
    <!-- TOP NAVIGATION -->
    <main-navigation></main-navigation>

    <!-- DASHBOARD CONTENT -->
    <div class="dashboard-content">
      <!-- HEADER -->
      <div class="dashboard-header">
        <div class="header-content">
          <div class="header-text">
            <h1>Property Dashboard</h1>
            <p>Overview of your property management data</p>
          </div>
          <div class="header-icon">
            <i class="bi bi-speedometer2"></i>
          </div>
        </div>
        <div class="header-subtitle">
          <span class="date-badge">{{ currentDate }}</span>
          <span class="data-summary">Total Properties: {{ houses.length }} • Total Units: {{ units.length }}</span>
        </div>
      </div>

      <!-- STATS -->
      <div class="stats-grid">
        <div class="stat-card houses-card">
          <div class="stat-icon"><i class="bi bi-house-door"></i></div>
          <div class="stat-content">
            <h3>Houses</h3>
            <p class="stat-value">{{ houses.length }}</p>
            <div class="stat-trend">Total Properties</div>
          </div>
          <div class="stat-badge primary">Properties</div>
        </div>

        <div class="stat-card units-card">
          <div class="stat-icon"><i class="bi bi-building"></i></div>
          <div class="stat-content">
            <h3>Units</h3>
            <p class="stat-value">{{ units.length }}</p>
            <div class="stat-trend">All Units</div>
          </div>
          <div class="stat-badge secondary">Units</div>
        </div>

        <div class="stat-card occupied-card">
          <div class="stat-icon"><i class="bi bi-check2-circle"></i></div>
          <div class="stat-content">
            <h3>Occupied Units</h3>
            <p class="stat-value">{{ occupiedUnits }}</p>
            <div class="stat-trend">{{ occupancyRate }}% occupancy</div>
          </div>
          <div class="stat-badge success">Occupied</div>
        </div>

        <div class="stat-card vacant-card">
          <div class="stat-icon"><i class="bi bi-door-open"></i></div>
          <div class="stat-content">
            <h3>Vacant Units</h3>
            <p class="stat-value">{{ vacantUnits }}</p>
            <div class="stat-trend">Available for rent</div>
          </div>
          <div class="stat-badge warning">Vacant</div>
        </div>

        <div class="stat-card tenants-card">
          <div class="stat-icon"><i class="bi bi-people"></i></div>
          <div class="stat-content">
            <h3>Tenants</h3>
            <p class="stat-value">{{ tenants.length }}</p>
            <div class="stat-trend">Active residents</div>
          </div>
          <div class="stat-badge info">Tenants</div>
        </div>

        <div class="stat-card money-card">
          <div class="stat-icon"><i class="bi bi-cash-stack"></i></div>
          <div class="stat-content">
            <h3>Monthly Collections</h3>
            <p class="stat-value">KES {{ monthlyCollections.toLocaleString() }}</p>
            <div class="stat-trend">This month's revenue</div>
          </div>
          <div class="stat-badge revenue">Revenue</div>
        </div>

        <div class="stat-card yearly-card">
          <div class="stat-icon"><i class="bi bi-calendar-range"></i></div>
          <div class="stat-content">
            <h3>Yearly Collections</h3>
            <p class="stat-value">KES {{ yearlyCollections.toLocaleString() }}</p>
            <div class="stat-trend">This year's revenue</div>
          </div>
          <div class="stat-badge revenue">Revenue</div>
        </div>
      </div>

      <!-- QUICK LINKS -->
      <div class="section-header">
        <h2>Quick Actions</h2>
        <p>Navigate to different management sections</p>
      </div>
      <div class="quick-links">
        <router-link to="/houses" class="link-card houses-link">
          <div class="link-icon"><i class="bi bi-house-door"></i></div>
          <div class="link-text">
            <h3>Manage Houses</h3>
            <p>View and manage all properties</p>
          </div>
          <div class="link-arrow"><i class="bi bi-arrow-right"></i></div>
        </router-link>
        
        <router-link to="/all/payments" class="link-card units-link">
          <div class="link-icon"><i class="bi bi-credit-card"></i></div>
          <div class="link-text">
            <h3>Payments</h3>
            <p>See all individual payments</p>
          </div>
          <div class="link-arrow"><i class="bi bi-arrow-right"></i></div>
        </router-link>
        
        <!-- <router-link to="/tenants" class="link-card tenants-link">
          <div class="link-icon"><i class="bi bi-building"></i></div>
          <div class="link-text">
            <h3>Tenants</h3>
            <p>Manage tenant information</p>
          </div>
          <div class="link-arrow"><i class="bi bi-arrow-right"></i></div>
        </router-link> -->
        
        <!-- <router-link to="/payments" class="link-card payments-link">
          <div class="link-icon"><i class="bi bi-credit-card"></i></div>
          <div class="link-text">
            <h3>Payments</h3>
            <p>Track rent and collections</p>
          </div>
          <div class="link-arrow"><i class="bi bi-arrow-right"></i></div>
        </router-link> -->

            <router-link to="/invoices" class="link-card payments-link">
          <div class="link-icon"><i class="bi bi-receipt"></i></div>
          <div class="link-text">
            <h3>View invoices</h3>
            <p>Generate invoices for all tenants</p>
          </div>
          <div class="link-arrow"><i class="bi bi-arrow-right"></i></div>
        </router-link>

        
            <router-link to="/monthly/billings" class="link-card payments-link">
          <div class="link-icon"><i class="bi bi-calendar-check"></i></div>
          <div class="link-text">
            <h3>View all Billings</h3>
            <p>View Initiate monthly bills to all tenants</p>
          </div>
          <div class="link-arrow"><i class="bi bi-arrow-right"></i></div>
        </router-link>
      </div>
    </div>

    <!-- LOADING OVERLAY -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <p>Loading dashboard data...</p>
    </div>
  </div>
</template>

<script>
import { apiFetch } from "@/services/api.js";

export default {
  name: "Dashboard",

  data() {
    return {
      houses: [],
      units: [],
      tenants: [],
      payments: [],
      monthlyCollections:0,
      yearlyCollections:0,
      loading: false,
      mobileMenuOpen: false
    };
  },

  computed: {
    occupiedUnits() {
      return this.units.filter(u => u.tenant_id).length;
    },

    vacantUnits() {
      return this.units.filter(u => !u.tenant_id).length;
    },


    occupancyRate() {
      if (this.units.length === 0) return 0;
      return Math.round((this.occupiedUnits / this.units.length) * 100);
    },

    currentDate() {
      return new Date().toLocaleDateString('en-US', { 
        weekday: 'long', 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    }
  },

  methods: {
    async loadHouses() {
      const res = await apiFetch("/houses");

      console.log("HOUSES API RAW RESPONSE:", res);

      if (Array.isArray(res)) {
        this.houses = res;
      } else if (res && Array.isArray(res.data)) {
        this.houses = res.data;
      } else if (res && Array.isArray(res.houses)) {
        this.houses = res.houses;
      } else if (res && Array.isArray(res.rows)) {
        this.houses = res.rows;
      } else {
        this.houses = [];
      }
    },

    async loadYearlyCollections(){
      const res = await apiFetch("/payments/yearly-summary");
      this.yearlyCollections = res?.data?.total_collected || 0;
    },

    async loadMonthlyCollections(){
      const res = await apiFetch("/payments/monthly-summary");
      this.monthlyCollections = res?.data?.total_collected || 0;
    },

    async loadUnits() {
      const res = await apiFetch("/units");
      this.units = Array.isArray(res) ? res : [];
    },

    async loadTenants() {
      const res = await apiFetch("/tenants");
      this.tenants = Array.isArray(res) ? res : [];
    },

    async loadPayments() {
      const res = await apiFetch("/payments");
      this.payments = Array.isArray(res) ? res : [];
    },

    handleLogout() {
      if (confirm("Are you sure you want to logout?")) {
        // Add your logout logic here
        console.log("Logging out...");
        // Example: this.$store.dispatch('logout');
        // Example: this.$router.push('/login');
      }
    },

    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },

    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  },

  async mounted() {
    try {
      this.loading = true;

      await Promise.all([
        this.loadHouses(),
        this.loadUnits(),
        this.loadTenants(),
        this.loadPayments(),
        this.loadMonthlyCollections(),
        this.loadYearlyCollections(),
      ]);

      const userId = localStorage.getItem('userId')
      console.log(userId)

      console.log("Dashboard loaded:", {
        houses: this.houses.length,
        units: this.units.length,
        tenants: this.tenants.length,
        payments: this.payments.length
      });

    } catch (err) {
      console.error("Dashboard load error", err);
    } finally {
      this.loading = false;
    }
  },


};
</script>

<style scoped>
/* ==========================================================================
   Dashboard overview. Layout is unchanged — this is colour, type and weight
   only, all pulled from assets/css/design.css so every screen matches.
   ========================================================================== */

.dashboard-content {
  padding: var(--dash-section-y) var(--dash-gutter) 56px;
  background: var(--dash-bg);
  min-height: calc(100vh - var(--dash-nav-h));
  font-family: var(--dash-font);
  color: var(--dash-text);
}

/* ---------- HEADER ---------- */
.dashboard-header {
  max-width: var(--dash-maxw);
  margin: 0 auto var(--dash-section-y);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
}

.header-text h1 {
  font-size: var(--dash-fs-display);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: var(--dash-lh-tight);
  color: var(--dash-ink);
  margin: 0 0 6px;
}

.header-text p {
  font-size: var(--dash-fs-sm);
  color: var(--dash-muted);
  margin: 0;
}

.header-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: var(--dash-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  background: var(--dash-primary-soft);
  color: var(--dash-primary-ink);
}

.header-subtitle {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.date-badge {
  background: var(--dash-surface);
  border: 1px solid var(--dash-line);
  padding: 6px 14px;
  border-radius: var(--dash-pill);
  font-size: var(--dash-fs-xs);
  font-weight: 600;
  color: var(--dash-text);
}

.data-summary {
  color: var(--dash-muted);
  font-size: var(--dash-fs-xs);
  font-variant-numeric: tabular-nums;
}

/* ---------- STATS ---------- */
.stats-grid {
  max-width: var(--dash-maxw);
  margin: 0 auto var(--dash-section-y);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: var(--dash-gap);
}
.yearly-card::before { background: var(--dash-success-ink); }
.yearly-card .stat-icon { background: var(--dash-success-soft); color: var(--dash-success-ink); }

.stat-card {
  background: var(--dash-surface);
  border: 1px solid var(--dash-line);
  border-radius: var(--dash-radius);
  padding: 20px 22px;
  box-shadow: var(--dash-shadow-xs);
  display: flex;
  align-items: center;
  gap: 18px;
  position: relative;
  overflow: hidden;
  transition: box-shadow var(--dash-t), transform var(--dash-t);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--dash-shadow);
}

/* Thin colour key down the left edge — the only decoration on the card */
.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
}

.houses-card::before   { background: var(--dash-primary); }
.units-card::before    { background: var(--dash-alt); }
.occupied-card::before { background: var(--dash-success); }
.vacant-card::before   { background: var(--dash-warning); }
.tenants-card::before  { background: var(--dash-primary-ink); }
.money-card::before    { background: var(--dash-success-ink); }

.stat-icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: var(--dash-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  background: var(--dash-bg-alt);
  color: var(--dash-text);
}

.houses-card .stat-icon,
.tenants-card .stat-icon  { background: var(--dash-primary-soft); color: var(--dash-primary-ink); }
.units-card .stat-icon    { background: var(--dash-alt-soft); color: var(--dash-alt-ink); }
.occupied-card .stat-icon,
.money-card .stat-icon    { background: var(--dash-success-soft); color: var(--dash-success-ink); }
.vacant-card .stat-icon   { background: var(--dash-warning-soft); color: var(--dash-warning-ink); }

.stat-content { flex: 1; min-width: 0; }

.stat-content h3 {
  font-size: var(--dash-fs-micro);
  color: var(--dash-muted);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: var(--dash-track-caps);
  margin: 0;
}

.stat-value {
  font-size: var(--dash-fs-figure);
  font-weight: 700;
  color: var(--dash-ink);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  margin: 6px 0 4px;
  line-height: 1.1;
  overflow-wrap: anywhere;
}

.stat-trend {
  font-size: var(--dash-fs-xs);
  color: var(--dash-muted);
  margin: 0;
}

.stat-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 4px 10px;
  border-radius: var(--dash-pill);
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: var(--dash-track-caps);
}

.primary   { background: var(--dash-primary-soft); color: var(--dash-primary-ink); }
.secondary { background: var(--dash-alt-soft); color: var(--dash-alt-ink); }
.success   { background: var(--dash-success-soft); color: var(--dash-success-ink); }
.warning   { background: var(--dash-warning-soft); color: var(--dash-warning-ink); }
.info      { background: var(--dash-primary-soft); color: var(--dash-primary-ink); }
.revenue   { background: var(--dash-success-soft); color: var(--dash-success-ink); }

/* ---------- QUICK ACTIONS ---------- */
.section-header {
  max-width: var(--dash-maxw);
  margin: 0 auto 16px;
}

.section-header h2 {
  font-size: var(--dash-fs-h2);
  font-weight: 650;
  color: var(--dash-ink);
  margin: 0 0 4px;
}

.section-header p {
  color: var(--dash-muted);
  font-size: var(--dash-fs-xs);
  margin: 0;
}

.quick-links {
  max-width: var(--dash-maxw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--dash-gap);
}

.link-card {
  background: var(--dash-surface);
  border: 1px solid var(--dash-line);
  border-radius: var(--dash-radius);
  padding: 18px 20px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: var(--dash-shadow-xs);
  transition: border-color var(--dash-t), box-shadow var(--dash-t), transform var(--dash-t);
}

.link-card:hover {
  transform: translateY(-2px);
  border-color: var(--dash-primary-line);
  box-shadow: var(--dash-shadow);
}

.link-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: var(--dash-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  background: var(--dash-primary-soft);
  color: var(--dash-primary-ink);
  transition: background var(--dash-t), color var(--dash-t);
}

.link-card:hover .link-icon {
  background: var(--dash-primary);
  color: #ffffff;
}

.link-text { flex: 1; min-width: 0; }

.link-text h3 {
  font-size: var(--dash-fs-body);
  font-weight: 650;
  color: var(--dash-ink);
  margin: 0 0 3px;
}

.link-text p {
  font-size: var(--dash-fs-xs);
  color: var(--dash-muted);
  margin: 0;
}

.link-arrow {
  font-size: 1rem;
  color: var(--dash-faint);
  transition: color var(--dash-t), transform var(--dash-t);
}

.link-card:hover .link-arrow {
  color: var(--dash-primary);
  transform: translateX(3px);
}

/* ---------- LOADING ---------- */
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(247, 246, 242, 0.88);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
  z-index: 1000;
  backdrop-filter: blur(3px);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--dash-line);
  border-top-color: var(--dash-primary);
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

.loading-overlay p {
  font-size: var(--dash-fs-sm);
  color: var(--dash-muted);
  font-weight: 600;
  margin: 0;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ---------- RESPONSIVE ---------- */
/* 14" laptops: three stat cards across still fit, keep the 320px floor */
@media (max-width: 1100px) {
  .stats-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: row;
    align-items: flex-start;
  }

  .stats-grid,
  .quick-links { grid-template-columns: 1fr; }

  .stat-card { padding: 18px; }
  .stat-badge { position: static; align-self: flex-start; }
}

@media (max-width: 480px) {
  .stat-card { gap: 14px; }
  .stat-icon { width: 44px; height: 44px; font-size: 1.15rem; }
  .header-subtitle { flex-direction: column; align-items: flex-start; gap: 8px; }
}

@media (prefers-reduced-motion: reduce) {
  .stat-card:hover,
  .link-card:hover { transform: none; }
}
</style>
